<form nz-form *ngIf="mainformGroup && fieldNew && controlExists" [formGroup]="mainformGroup" [nzLayout]="'vertical'">
    <nz-form-item *ngIf="!field.hidden" [ngStyle]="field.noFormItemMarginBottom?{'margin-bottom':'0'}:{}">
        <nz-form-label [nzFor]="fieldNew" *ngIf="!field.noLabel" [nzRequired]="field.required">{{field.label|translateTA}}</nz-form-label>
        <nz-form-control [nzValidatingTip]="field.tooltip" nzHasFeedback>    
            <!-- Com prefixo/sufixo: usar nz-input-group -->
            <nz-input-group *ngIf="field.addonBefore || field.addonAfter" [nzAddOnBefore]="field.addonBefore" [nzAddOnAfter]="field.addonAfter">
                <nz-input-number 
                    [style.width.%]="100" 
                    [formControlName]="fieldNew" 
                    [nzPrecision]="field.precision?field.precision:null"
                    [nzPlaceHolder]="field.placeholder|translateTA" 
                    [nzSize]="field.size == null ? 'default' : field.size" 
                    [nzDisabled]="field.isDisabled"
                    [nzMin]="field.min" 
                    [nzMax]="field.max"
                    [nzFormatter]="nzFormatter"
                    [nzParser]="nzParser">
                    @if (mainformGroup.get(field.field)?.value) {
                        <nz-icon nzInputPrefix class="ant-input-clear-icon" nzTheme="fill" nzType="close-circle" (click)="mainformGroup.get(field.field).setValue(null)" />
                    }
                </nz-input-number>
            </nz-input-group>
            
            <!-- Sem prefixo/sufixo: usar nz-input-number direto -->
            <nz-input-number 
                *ngIf="!field.addonBefore && !field.addonAfter"
                [style.width.%]="100" 
                [nzPrecision]="field.precision?field.precision:null"
                [formControlName]="fieldNew" 
                [nzPlaceHolder]="field.placeholder|translateTA" 
                [nzSize]="field.size == null ? 'default' : field.size" 
                [nzDisabled]="field.isDisabled"
                [nzMin]="field.min" 
                [nzMax]="field.max"
                [nzFormatter]="nzFormatter"
                [nzParser]="nzParser">
                @if (mainformGroup.get(field.field)?.value) {
                    <nz-icon nzInputPrefix class="ant-input-clear-icon" nzTheme="fill" nzType="close-circle" (click)="mainformGroup.get(field.field).setValue(null)" />
                }
            </nz-input-number>
        </nz-form-control>
    </nz-form-item>
</form>


